import {disableScroll, enableScroll} from "./utils/disableScroll";
import {getElement, getElements} from "./utils/getElement";

const initHeaderMenu = () => {
    const menuButton = getElement('.js-header-trigger')
    const mobileMenu = getElement('.js-mobile-menu')
    const allSubmenus = getElements('.js-nested-submenu')

    const disableScroll = () => {
        document.body.style.overflow = 'hidden';
    };

    const enableScroll = () => {
        document.body.style.overflow = '';
    };

    if (!menuButton || !mobileMenu || !allSubmenus) {
        return null;
    }

    const toggleMobileMenu = () => {
        if (mobileMenu.classList.contains('is-open')) {
            enableScroll()
        } else {
            disableScroll()
        }

        if (mobileMenu.classList.contains('is-open')) {
            enableScroll()
        } else {
            disableScroll()
        }

        mobileMenu.classList.toggle('is-open');
        menuButton.classList.toggle('is-active');

        allSubmenus.map(submenu => {
            submenu.classList.remove('is-open')
        })
    }

    menuButton.addEventListener('click', toggleMobileMenu);
}

export {initHeaderMenu}
